export default {"src":"/_next/static/media/gy.d0c9e591.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};